export const downloadDocumentWithLink = (url: string, title: string, extention?: string) => {
    const a = document.createElement('a');
    a.setAttribute('href', url);
    a.setAttribute('download', extention ? `${title}.${extention}` : `${title}`);
    a.click();
};
